<script setup lang="ts">
import { ref, computed } from 'vue'
import { DESKTOP } from '~/constant/common'
import { EnquiryStepEnum } from '~/enum/enquiry'
import SectionContentHTW from '~/components/pages/Enquiry/MultiStepsForm/Elements/SectionContentHTW.vue'
import BottomSheet from '~/components/ui/bottom-sheet/BottomSheet.vue'
import { useEnquiryCaptureStore } from '~/store/pinia/enquiryCapture'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

const emits = defineEmits(['nextStep', 'prevStep'])

const contentsBottom = {
  first: 'Planning your trip costs you nothing',
  final: 'A detailed, tailored trip plan awaits',
  [EnquiryStepEnum.Information]: 'Your Information',
  [EnquiryStepEnum.YourTrip]: 'Your Trip ',
  [EnquiryStepEnum.How]: 'Travellers & Accommodation',
  [EnquiryStepEnum.YourStyle]: 'Your Style',
  [EnquiryStepEnum.YourBudget]: 'Estimated Price & Budget',
}
const props = defineProps({
  buttonId: { type: String, default: '' },
  labelClass: { type: Object, default: () => {} },
  stepActive: { type: String, default: EnquiryStepEnum.Information },
  disableSubmitButton: { type: Boolean, default: false },
  isUIPopup: { type: Boolean, default: false },
})

const enquiryCaptureStore = useEnquiryCaptureStore()
const modalActiveHIW = ref(false)
const generalStore = useGeneralInfoStore()

const windowWidth = computed(() => generalStore.generalData.windowWidth)
const isDesktop = computed(() => windowWidth.value > DESKTOP)
const arrayStepEnquiry = computed(() => enquiryCaptureStore.arrayStep)
const firstIndex = 0
const lastIndex = arrayStepEnquiry.value.length - 1

const buttonText = computed(() => {
  return props.stepActive === EnquiryStepEnum.YourBudget ? 'Complete' : 'Continue'
})
const labelFooter = computed(() => {
  switch (props.stepActive) {
    case arrayStepEnquiry.value[firstIndex]:
      return contentsBottom.first
    case arrayStepEnquiry.value[lastIndex]:
      return contentsBottom.final
    default:
      const index = arrayStepEnquiry.value.indexOf(props.stepActive as EnquiryStepEnum)
      return `Next: ${contentsBottom[arrayStepEnquiry.value[index + 1] as EnquiryStepEnum]}`
  }
})

const triggerBottomSheetHIW = (value: boolean) => {
  modalActiveHIW.value = value
}
</script>

<template>
  <div>
    <div v-if="disableSubmitButton" class="mask-loading"></div>
    <div class="fixed bottom-0 left-0 z-999 wp-100 footer-form px-16 pt-10 pb-7 bg-white" :class="isDesktop ? 'sticky' : 'fixed'">
      <!--    <slot></slot>-->
      <div class="flex">
        <template v-if="stepActive === arrayStepEnquiry[firstIndex]">
          <a
            v-if="windowWidth > DESKTOP"
            id="enquiry-form-button-how-it-work"
            class="button button-gray-50 mr-8 w-181 tnw"
            style="font-size: 16px"
            href="/how-it-works"
            target="_blank"
            >How It Works?</a
          >
          <button v-else id="enquiry-form-button-how-it-work" class="button button-gray-50 mr-8 w-181 tnw" @click.prevent="triggerBottomSheetHIW(true)">
            How It Works?
          </button>
        </template>
        <template v-else-if="!isUIPopup">
          <button class="button button-gray-50 mr-8 w-181" @click.prevent="$emit('prevStep')">
            <span class="fs-14 lh-20 fw-600">Back</span>
          </button>
        </template>
        <div class="wp-100">
<!--          <ButtonLoading v-if="disableSubmitButton" :btnLabel="buttonText" :btnClass="['wp-100', labelClass?.submitButtonClass]" />-->
          <button
            :id="buttonId"
            :class="['wp-100 flex items-center', labelClass?.submitButtonClass, disableSubmitButton ? 'cursor-wait pointer-none button-gray-400' : 'button-primary']"
            type="button"
            @click.prevent="$emit('nextStep')"
          >
            <span class="mr-8">{{ buttonText }}</span>
<!--            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
              <path d="M1.25 1.625L5.625 6L1.25 10.375" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>-->
          </button>
        </div>
      </div>
      <div class="tc fs-14 fw-500 lh-20 gray-700-brand pt-10 mb-fs-12 mb-fw-500">{{ labelFooter }}</div>
    </div>
    <BottomSheet v-if="!isDesktop && stepActive === arrayStepEnquiry[firstIndex]" v-model:visible="modalActiveHIW" height="625px">
      <template #content>
        <SectionContentHTW @close="triggerBottomSheetHIW(false)" />
      </template>
    </BottomSheet>
  </div>
</template>

<style scoped lang="scss">
.footer-form {
  border-top: 1px solid brandColor(gray, 200);
  box-shadow: 0px -5px 8px 0px rgba(0, 0, 0, 0.04);
}
.mask-loading {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.1);
  z-index: 1005;
}
</style>
